import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { legalDocuments } from "@/content/legalDocuments";

export default function LocationDisclaimer() {
  return <LegalDocumentPage document={legalDocuments.locations} />;
}